var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSnp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_409_11506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0969 17.8396C15.6111 17.6255 15.0447 17.8512 14.8354 18.3379C13.8486 20.6112 11.605 22.0799 9.11959 22.0799C5.67897 22.0799 2.87959 19.2806 2.87959 15.8399C2.87959 13.6089 4.08152 11.5382 6.01497 10.4332C6.47674 10.1712 6.63611 9.58461 6.37305 9.12378C6.11097 8.663 5.52344 8.49978 5.06359 8.76664C2.53206 10.2114 0.959595 12.9215 0.959595 15.8399C0.959595 20.3395 4.62006 23.9999 9.11959 23.9999C12.3711 23.9999 15.3058 22.0771 16.5961 19.102C16.8073 18.6163 16.5845 18.0508 16.0969 17.8396Z",
    fill: "#333399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9715 18.8438C22.7737 18.3504 22.2189 18.1104 21.7235 18.3082L20.2873 18.8832L18.1974 12.1939C18.0716 11.7926 17.7001 11.52 17.2796 11.52H10.4233L10.1248 9.6H13.9196C14.4505 9.6 14.8796 9.17086 14.8796 8.64C14.8796 8.10914 14.4505 7.68 13.9196 7.68H9.82717L9.33086 4.48223C10.0605 4.06945 10.5596 3.29662 10.5596 2.4C10.5596 1.07616 9.48349 0 8.15964 0C6.83678 0 5.75964 1.07616 5.75964 2.4C5.75964 3.4627 6.4585 4.35553 7.41757 4.67039L8.65117 12.6269C8.72416 13.0953 9.12639 13.44 9.59964 13.44H16.574L18.7628 20.4461C18.8434 20.7015 19.0259 20.9117 19.2678 21.0269C19.3974 21.0892 19.5395 21.12 19.6796 21.12C19.8006 21.12 19.9216 21.0979 20.0368 21.0518L22.4368 20.0918C22.9293 19.8951 23.1683 19.3363 22.9715 18.8438Z",
    fill: "#333399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_409_11506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSnp);
export default __webpack_public_path__ + "static/media/totalSNP.9d8ff28bf82bf43b51bc828982c16909.svg";
export { ForwardRef as ReactComponent };